










import { Component, Vue } from "vue-property-decorator";
import Footer from "./components/Footer/components";
import Loading from "@/components/Loading/components";
import { Action, Getter } from "vuex-class";
import store from "./store";
import { AxiosError } from "axios";
import { Dictionary } from "vue-router/types/router";

@Component({
  components: {
    Footer,
    Loading,
  },
})
export default class App extends Vue {
  // @Action("getConfiguracionGeneral", { namespace: "general" }) getConfiguracionGeneral!: Function;
  @Getter("isLogged", { namespace: "auth" }) isLogged!: boolean;
  @Action("screenResize") screenResize!: Function;

  public loading = false;
  public keyQtt = 0;

  created(){
    this.$root.$on("loading", (loading: boolean) => {
      this.loading = loading;
      this.keyQtt++;
    });

    //check if user is logged in, compare version number and logout if not equal
    
  }

  public onResize() {
    this.screenResize();
  }
  async mounted() {
    //
  }
}
